import * as React from "react";
import { Link } from "react-router-dom";
import { Table } from "@coverme/table";
import "./DataHolder.scss";
import { getNavigationUrl } from "../../services/encounterNavigationService";
import * as moment from "moment";
import { some } from "lodash-es";

export const ReportingTable = ({ pagedCases, onFetchData, isLoading, isProgramForm, customerFeatures }) => {
    const isTagsEnabled = some(customerFeatures, x => x === "Tags");
    const tagsColumn = {
        Header: <span>Tag</span>,
        sortable: false,
        accessor: "tag",
        Cell: props => {
            const uci = props.original.uci;
            props.original.tag;
            return <span id={uci + "_tag"}>{props.value}</span>;
        },
    };

    const actionColumn = {
        Header: props => <span></span>,
        headerClassName: "",
        className: "my-cases-table__facesheet-icon",
        sortable: false,
        accessor: "globalId",
        width: 50,
        style: {
            justifyContent: "center",
        },
        Cell: props => {
            return (
                <Link to={getNavigationUrl(props.original)}>
                    <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 15 15"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-420.000000, -155.000000)" fill="#1A72E5">
                                <g transform="translate(165.000000, 129.000000)">
                                    <g transform="translate(19.000000, 25.000000)">
                                        <path d="M249.333333,14.3333333 L237.666667,14.3333333 L237.666667,2.66666667 L243.5,2.66666667 L243.5,1 L237.666667,1 C236.741667,1 236,1.75 236,2.66666667 L236,14.3333333 C236,15.25 236.741667,16 237.666667,16 L249.333333,16 C250.25,16 251,15.25 251,14.3333333 L251,8.5 L249.333333,8.5 L249.333333,14.3333333 L249.333333,14.3333333 Z M245.44864,1 L245.44864,2.58610272 L248.295695,2.58610272 L240.5,10.3817976 L241.618202,11.5 L249.413897,3.70430514 L249.413897,6.55135952 L251,6.55135952 L251,1 L245.44864,1 L245.44864,1 Z" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </Link>
            );
        },
    };

    const columns = [
        {
            Header: () => <span>Name</span>,
            sortable: true,
            accessor: "patientName",
            Cell: props => {
                const uci = props.original.uci;
                const navigationUrl = getNavigationUrl(props.original);
                return (
                    <Link style={{ cursor: "pointer" }} to={navigationUrl}>
                        {props.value}
                    </Link>
                );
            },
        },
        {
            Header: <span>MRN</span>,
            sortable: false,
            accessor: "mrn",
            width: 150,
            Cell: props => {
                const uci = props.original.uci;
                props.original.mrn;
                return <span id={uci + "_mrn"}>{props.value}</span>;
            },
        },
        {
            Header: <span>Tag</span>,
            sortable: false,
            accessor: "tag",
            Cell: props => {
                const uci = props.original.uci;
                props.original.tag;
                return <span id={uci + "_tag"}>{props.value}</span>;
            },
        },
        {
            Header: "Coverage",
            sortable: false,
            accessor: "selectedPrograms",
            Cell: props => {
                const uci = props.original.uci;
                return <span id={uci + "_program"}>{props.value.join(", ")}</span>;
            },
        },
        {
            Header: <span>Status</span>,
            sortable: false,
            accessor: "status",
            width: 120,
            Cell: props => {
                const uci = props.original.uci;
                return <span id={uci + "_status"}>{props.value}</span>;
            },
            show: !isProgramForm,
        },
        {
            Header: () => <div className="text_center">Documents</div>,
            sortable: true,
            width: 150,
            accessor: "documentsCount",
            Cell: props => {
                const uci = props.original.uci;
                const value =
                    props.value !== undefined && props.value !== null ? moment(props.value).format("MM/DD/YYYY") : "";
                return (
                    <span className="text_center" id={uci + "_encounter_date"}>
                        {props.value}
                    </span>
                );
            },
        },
        {
            Header: () => <div className="text_center">Notes</div>,
            sortable: true,
            width: 150,
            accessor: "notesCount",
            Cell: props => {
                const uci = props.original.uci;
                const value =
                    props.value !== undefined && props.value !== null ? moment(props.value).format("MM/DD/YYYY") : "";
                return (
                    <span className="text_center" id={uci + "_encounter_date"}>
                        {props.value}
                    </span>
                );
            },
        },
        {
            Header: () => <div className="text_center">Service Date</div>,
            sortable: true,
            width: 150,
            accessor: "serviceStartDate",
            Cell: props => {
                const uci = props.original.uci;
                const value =
                    props.value !== undefined && props.value !== null ? moment(props.value).format("MM/DD/YYYY") : "";
                return (
                    <span className="text_center" id={uci + "_encounter_date"}>
                        {value}
                    </span>
                );
            },
        },
    ];
    let finalColumns = [];
    finalColumns = [...columns, actionColumn];
    return (
        <div className="my-cases-table">
            <div className="table-container">
                <div className="totalRecordNumber p-regular">
                    {pagedCases.data.length > 0 ? pagedCases.totalRecordNumberInQuery : 0} Results Found
                </div>
                <Table
                    data={pagedCases.data}
                    defaultSorted={[{ id: "created", desc: true }]}
                    columns={finalColumns}
                    showPagination={true}
                    defaultPageSize={20}
                    manual
                    loading={isLoading}
                    pages={pagedCases.data.length > 0 ? pagedCases.totalNumberOfPages : 1}
                    onFetchData={onFetchData}
                    minRows={1}
                />
            </div>
        </div>
    );
};
